/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Pilot_Ready_Preview_ActionInputs */



/**
* | output |
* | --- |
* | "Practise" |
*
* @param {Onboarding_Pilot_Ready_Preview_ActionInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_pilot_ready_preview_action = /** @type {((inputs?: Onboarding_Pilot_Ready_Preview_ActionInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pilot_Ready_Preview_ActionInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Oefenen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("S’entraîner")
	return /** @type {LocalizedString} */ ("Practise")
});